export default "__VITE_ASSET__DIRuFM2C__"